import { apiProxyRequest } from "Api/apiProxyRequest";

export const enrollTFARequest = ({
  userId,
  secret,
  passcode
}: {
  userId: string;
  secret: string;
  passcode: string;
}) =>
  apiProxyRequest<{ recovery_codes: string[] }>(
    `/users/${userId}/totp`,
    "POST",
    { secret, passcode }
  );
